import Appointments from './Appointments';
import TimelineTooltipContainer from './TimelineTooltipContainer';
import { PlanningEntityIdentifier } from 'generated';
import usePlanningEntity from '../../hooks/usePlanningEntity';
import { getItemWidthInPixels } from '../utils';
import { EditAppointmentType } from 'RestAPIs/activities/types';
import { useNavParams } from 'hooks';
import { View } from '../../enums';
import { PlanningEntity } from '../../types';
import { ZoomLevel } from '../TimelineBar/TimelineBar.enums';
import { Interval } from '../types';
import { HighlightedRoute } from './TimelineRoute.styles';

interface Props {
  activeEntityContainingSelection: string | null;
  onChangeMousePosition?: (pos: { x: number; y: number }) => void;
  onChangeActiveEntity?: (entityId: string) => void;
  onChangeSelection?: (selectionIds: string[]) => void;
  timelineRouteWidth: number;
  timeBarItemWidth: number;
  positionOffset: number;
  interval: Interval;
  planningEntity: PlanningEntity;
  zoomLevel: ZoomLevel;
  connectAppointmentGrouping: (
    appointmentGroupingEntityId: string,
    editAppointmentType?: EditAppointmentType,
    scheduleStart?: string
  ) => void;
  connectSchedule?: (
    planningEntityIdentifier?: PlanningEntityIdentifier,
    scheduleStart?: string
  ) => void;
}

export default function TimelineRoute(props: Props) {
  const {
    activeEntityContainingSelection,
    connectAppointmentGrouping,
    connectSchedule,
    positionOffset,
    interval,
    onChangeMousePosition,
    onChangeActiveEntity,
    onChangeSelection,
    planningEntity,
    zoomLevel
  } = props;
  const { planningEntityIdentifier, schedules } = planningEntity;
  const { start } = schedules?.[0] || {};

  const { params } = useNavParams();
  const view = params?.view as View;

  const [planningEntityTypePreference] = usePlanningEntity();
  const planningEntityType = planningEntityTypePreference[view];

  const widthInPixels = getItemWidthInPixels(
    props.timeBarItemWidth,
    interval.durationInSeconds,
    zoomLevel
  );

  return (
    <HighlightedRoute
      sx={{
        position: 'relative',
        width: widthInPixels
      }}
      className={`__${planningEntity?.id}__`}
    >
      <TimelineTooltipContainer
        planningEntity={planningEntity}
        scheduleStart={start}
        start={interval.start}
        positionOffset={positionOffset}
        planningEntityIdentifier={planningEntityIdentifier}
        zoomLevel={zoomLevel}
        timeBarItemWidth={props.timeBarItemWidth}
      >
        <Appointments
          activeEntityContainingSelection={activeEntityContainingSelection}
          connectAppointmentGrouping={connectAppointmentGrouping}
          connectSchedule={connectSchedule}
          planningEntity={planningEntity}
          planningEntityType={planningEntityType}
          interval={interval}
          zoomLevel={zoomLevel}
          timeBarItemWidth={props.timeBarItemWidth}
          onChangeMousePosition={onChangeMousePosition}
          onChangeActiveEntity={onChangeActiveEntity}
          onChangeSelection={onChangeSelection}
        />
      </TimelineTooltipContainer>
    </HighlightedRoute>
  );
}
